import { MailX } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { StatusCard } from "@/features/auth/components/status-card";

interface InviteErrorCopy {
	title: string;
	description: string;
	actionLabel: string;
	actionTo: string;
}

const INVITE_ERRORS: Record<string, InviteErrorCopy> = {
	"waitlist-invite-expired": {
		title: "Convite expirado",
		description:
			"Este convite expirou. Entre na lista de espera novamente para receber um novo acesso.",
		actionLabel: "Entrar na lista de espera",
		actionTo: "/onboarding",
	},
	"waitlist-invite-already-used": {
		title: "Convite já utilizado",
		description:
			"Este convite já foi usado para criar uma conta. Faça login para acessar.",
		actionLabel: "Ir para o login",
		actionTo: "/login",
	},
};

const UNKNOWN_INVITE: InviteErrorCopy = {
	title: "Convite inválido",
	description: "Este link de convite é inválido ou não existe mais.",
	actionLabel: "Entrar na lista de espera",
	actionTo: "/onboarding",
};

interface WaitlistInviteErrorProps {
	reason: string;
}

export function WaitlistInviteError({ reason }: WaitlistInviteErrorProps) {
	const copy = INVITE_ERRORS[reason] ?? UNKNOWN_INVITE;

	return (
		<StatusCard
			tone="danger"
			icon={<MailX />}
			title={copy.title}
			description={copy.description}
			action={
				<Button asChild className="status-card__action">
					<Link to={copy.actionTo}>{copy.actionLabel}</Link>
				</Button>
			}
		/>
	);
}
